import { EditorOperatorEnum } from "@/state/editor-store";

export const EditorOperatorConfigMap = {
  [EditorOperatorEnum.INTRO]: {
    min: 5,
    max: 15,
    default: 10,
    disabled: false
  },
  [EditorOperatorEnum.TRIM]: {
    min: 0,
    max: 90,
    default: 0,
    disabled: true
  },
  [EditorOperatorEnum.REFILL]: {
    min: 5,
    max: 30,
    default: 0,
    disabled: true
  },
  [EditorOperatorEnum.EXTEND]: {
    min: 60,
    max: 90,
    default: 60,
    disabled: false
  },
  [EditorOperatorEnum.FADE_OUT]: {
    min: 3,
    max: 5,
    default: 3,
    disabled: false
  },
  [EditorOperatorEnum.OUTRO]: {
    min: 5,
    max: 15,
    default: 10,
    disabled: false
  },
  [EditorOperatorEnum.NONE]: {
    min: 0,
    max: 0,
    default: 0,
    disabled: false
  },
}
export const createAudioContext = () => new (window.AudioContext || window.AudioContext)();

export const processAudioBuffer = async (
  wavesurfer: any,
  processor: (currentBuffer: AudioBuffer, audioContext: AudioContext) => Promise<[AudioBuffer, number]>
): Promise<void> => {
  const audioContext = createAudioContext();
  const currentBuffer = wavesurfer.getDecodedData();
  if (!currentBuffer) {
    throw new Error('No audio data loaded');
  }

  const [newBuffer, newDuration] = await processor(currentBuffer, audioContext);

  // Convert to channel data format for wavesurfer
  const channelData: Float32Array[] = [];
  for (let i = 0; i < newBuffer.numberOfChannels; i++) {
    channelData.push(newBuffer.getChannelData(i));
  }

  // Load the new buffer
  await wavesurfer.load('', channelData, newDuration);
};

// Helper function to write strings to DataView
export function writeString(view: DataView, offset: number, string: string) {
  for (let i = 0; i < string.length; i++) {
    view.setUint8(offset + i, string.charCodeAt(i));
  }
}
